import { render, staticRenderFns } from "./InvoiceServiceView.vue?vue&type=template&id=4df9901a&scoped=true&"
import script from "./InvoiceServiceView.vue?vue&type=script&lang=js&"
export * from "./InvoiceServiceView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceServiceView.vue?vue&type=style&index=0&id=4df9901a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df9901a",
  null
  
)

export default component.exports